import { Wrapper } from '@googlemaps/react-wrapper';
import { Row, Typography } from 'antd';
import { VFC } from 'react';
import { theme } from 'consts/theme';
import { FormattedMessage, useIntl } from 'react-intl';
import { SerializedMeter } from '@enmon/commons/lib/enmon';
import { GOOGLE_MAPS_API_KEY } from '../../consts/common';
import { useFloorplan } from '../../hooks/useFloorplan';
import { LoadingSpinner } from '../LoadingSpinner';
import { Map } from './Map';
import { FloorplanMarker } from './Marker';
import { Floorplan as messages } from './messages';

export interface FloorplanProps {
  buildingId?: number;
  locationId?: number;
  buildingFloor: NonNullable<SerializedMeter['buildingFloor']>;
  editable?: boolean;
  markers?: FloorplanMarker[];
  onMarkerDragEnd?: (updatedMarker: FloorplanMarker) => void;
}

export const Floorplan: VFC<FloorplanProps> = ({
  buildingFloor,
  locationId,
  buildingId,
  editable,
  markers,
  onMarkerDragEnd,
}) => {
  const { floorplan, loading } = useFloorplan(buildingFloor, buildingId, locationId);
  const intl = useIntl();

  if (loading) return <LoadingSpinner message={intl.formatMessage(messages.loadingLocationFloorPlan)} />;

  if (!floorplan)
    return (
      <Row justify="space-around">
        <Typography.Paragraph style={{ fontSize: 16, color: theme.colors.dark }}>
          <FormattedMessage {...messages.floorplanPhotoNotExists} />
        </Typography.Paragraph>
      </Row>
    );

  return (
    <Wrapper apiKey={GOOGLE_MAPS_API_KEY}>
      <Map editable={editable} floorplan={floorplan} markers={markers} onMarkerDragEnd={onMarkerDragEnd} />
    </Wrapper>
  );
};
